import { ITransform } from '@kurtosys/types/data/ITransform.js';
import { TTransformOperator } from '@kurtosys/types/data/TTransformOperator.js';

import { isNumber } from './typeChecks.js';

export function transform(initialValue: number, transforms: ITransform[]): number | undefined {
	if (!isNumber(initialValue) || transforms.find((transform) => !transform || !isNumber(transform.value))) {
		return;
	}
	return transforms.reduce((runningValue, transform) => {
		if (isNumber(runningValue)) {
			const { operator, order, value } = transform;
			const transformFunction = transformFunctions[operator];
			if (transformFunction) {
				if (!order || order === 'initialValueFirst') {
					runningValue = transformFunction(runningValue, value);
				}
				if (order === 'initialValueLast') {
					runningValue = transformFunction(value, runningValue);
				}
			}
		}
		return runningValue;
	}, initialValue);
}

const transformFunctions: { [key in TTransformOperator]: (a: number, b: number) => number } = {
	add: (a: number, b: number) => a + b,
	subtract: (a: number, b: number) => a - b,
	divide: (a: number, b: number) => {
		if (b === 0) {
			return undefined;
		}
		return a / b;
	},
	multiply: (a: number, b: number) => a * b,
};
